module.exports = __webpack_public_path__ + "img/hongbao.e447f540.png";